<app-jurormenu></app-jurormenu>
<h2 class='text-danger'>Entries Not Rated</h2>
<div>
    <ul *ngFor="let entry of entries" style="width: 40%">
        <li *ngIf="entry.jurorSelection === 0">
                {{ entry.submissionID }}
                <div class="row border m3">
                    <app-showimg [showDesc]="false" class="col" *ngIf="entry.numEntries >= 1" [entryImage]='entry.entryImage1'></app-showimg>
                    <app-select-entry class="col-auto align-self-center" 
                        (selectEntry)='selectEntry(entry.submissionID, $event)' 
                        [entry]='entry' *ngIf="router.url !== '/peak'">
                    </app-select-entry>
                    <app-showimg [showDesc]="false" class="col" *ngIf="entry.numEntries === 2" [entryImage]='entry.entryImage2'></app-showimg>
                </div>
        </li>
    </ul>
</div>